import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Linkedin, User } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const TINTS = ['bg-[#D7FF38]', 'bg-[#365CFF]', 'bg-[#F5F3EB]', 'bg-[#111]'];

const Placeholder = ({ i }) => (
  <li className="border-2 border-dashed border-[#111] bg-[#F5F3EB]/60 p-4" data-testid={`speaker-placeholder-${i}`}>
    <div className="aspect-square border-2 border-[#111] bg-[#F5F3EB] flex items-center justify-center cv-dots">
      <span className="cv-display text-6xl font-extrabold text-[#111]/25">?</span>
    </div>
    <p className="mt-3 cv-display text-lg font-extrabold uppercase">Speaker to be announced</p>
    <p className="text-[11px] font-bold uppercase tracking-wider text-[#111]/60">Coming soon</p>
  </li>
);

const Card = ({ s, i }) => (
  <li className="bg-[#F5F3EB] border-2 border-[#111] shadow-[5px_5px_0_#111] p-4 cv-lift" data-testid={`speaker-card-${s.id}`}>
    <div className={`aspect-square border-2 border-[#111] overflow-hidden flex items-center justify-center ${TINTS[i % TINTS.length]}`}>
      {s.photo_url
        ? <img src={`${API}${s.photo_url}`} alt={s.name} className="w-full h-full object-cover grayscale-[20%]" loading="lazy" />
        : <User size={56} className={i % 4 === 3 ? 'text-[#F5F3EB]' : 'text-[#111]'} />}
    </div>
    <p className="mt-3 cv-display text-sm sm:text-lg font-extrabold uppercase leading-tight [overflow-wrap:anywhere] sm:[overflow-wrap:normal] hyphens-auto" lang="en">{s.name}</p>
    {(s.title || s.company) && <p className="text-xs font-medium mt-1">{[s.title, s.company].filter(Boolean).join(' · ')}</p>}
    {s.linkedin_url && (
      <a href={s.linkedin_url} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wider border-2 border-[#111] bg-white px-2 py-1 hover:bg-[#D7FF38] transition-colors" data-testid={`speaker-linkedin-${s.id}`}>
        <Linkedin size={12} /> LinkedIn<span className="sr-only"> profile of {s.name} (opens in new tab)</span>
      </a>
    )}
  </li>
);

export const ConvergeSpeakers = () => {
  const [speakers, setSpeakers] = useState(null);
  const [enabled, setEnabled] = useState(true);
  useEffect(() => {
    axios.get(`${API}/api/public/converge/speakers`, { params: { _: Date.now() } })
      .then((r) => { setSpeakers(r.data.speakers || []); setEnabled(r.data.section_enabled !== false); })
      .catch(() => setSpeakers([]));
  }, []);
  if (!enabled) return null;
  const none = !speakers || speakers.length === 0;
  return (
    <div className="mt-12" data-testid="conclave-speakers-grid">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h3 className="cv-display text-3xl sm:text-5xl font-extrabold uppercase">Speakers</h3>
        {none && <p className="text-xs font-extrabold uppercase tracking-wider bg-[#111] text-[#FF6338] px-3 py-2" data-testid="conclave-speakers">Speaker announcements coming soon</p>}
      </div>
      <ul className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {none ? [1, 2, 3, 4].map((i) => <Placeholder key={i} i={i} />) : speakers.map((s, i) => <Card key={s.id} s={s} i={i} />)}
      </ul>
    </div>
  );
};
